import { render, staticRenderFns } from "./InfoLogic.vue?vue&type=template&id=5280331e&scoped=true&"
import script from "./InfoLogic.vue?vue&type=script&lang=js&"
export * from "./InfoLogic.vue?vue&type=script&lang=js&"
import style0 from "./InfoLogic.vue?vue&type=style&index=0&id=5280331e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280331e",
  null
  
)

export default component.exports